import { useQuery } from "react-query";
import { showErrorToast } from "~/components/Toast";
import i18n from "~/i18n";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";

export const useCapacity = (queryData = {}, config) => {
  //from, to, scale, users
  const query = encodeData(queryData);
  return useQuery({
    ...config,
    queryKey: ["capacity", query],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/reports/capacity?${query}`,
        signal,
      }),
    onError: (error) => {
      showErrorToast(error.message || i18n.t("Unable to load capacity data."));
    },
  });
};

export const useUtilization = (queryData = {}, config) => {
  //from, to, scale, users, show_only_billable
  const query = encodeData(queryData);
  return useQuery({
    ...config,
    queryKey: ["utilization", query],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/reports/utilization?${query}`,
        signal,
      }),
    onError: (error) => {
      showErrorToast(error.message || i18n.t("Unable to load utilization data."));
    },
  });
};
